export const FETCH_VEHICLE_SNAPSHOTS = 'FETCH_VEHICLE_SNAPSHOTS'
export const VEHICLE_SNAPSHOTS_RECEIVED = 'VEHICLE_SNAPSHOTS_RECEIVED'
export const VEHICLE_SNAPSHOTS_FAILED = 'VEHICLE_SNAPSHOTS_FAILED'

export const CREATE_VEHICLE_SNAPSHOT = 'CREATE_VEHICLE_SNAPSHOT'
export const VEHICLE_SNAPSHOT_CREATED = 'VEHICLE_SNAPSHOT_CREATED'
export const VEHICLE_SNAPSHOT_CREATE_FAILED = 'VEHICLE_SNAPSHOT_CREATE_FAILED'

export const DELETE_VEHICLE_SNAPSHOT = 'DELETE_VEHICLE_SNAPSHOT'
export const VEHICLE_SNAPSHOT_DELETED = 'VEHICLE_SNAPSHOT_DELETED'
export const VEHICLE_SNAPSHOT_DELETE_FAILED = 'VEHICLE_SNAPSHOT_DELETE_FAILED'

export const fetchVehicleSnapshots = (serialNumber) => ({
  type: FETCH_VEHICLE_SNAPSHOTS,
  payload: { serialNumber },
})

export const vehicleSnapshotsReceived = (serialNumber, snapshots) => ({
  type: VEHICLE_SNAPSHOTS_RECEIVED,
  payload: { serialNumber, snapshots },
})

export const vehicleSnapshotsFailed = (serialNumber, error) => ({
  type: VEHICLE_SNAPSHOTS_FAILED,
  payload: { serialNumber, error },
})

export const createVehicleSnapshot = (serialNumber) => ({
  type: CREATE_VEHICLE_SNAPSHOT,
  payload: { serialNumber },
})

export const vehicleSnapshotCreated = (serialNumber, snapshot) => ({
  type: VEHICLE_SNAPSHOT_CREATED,
  payload: { serialNumber, snapshot },
})

export const vehicleSnapshotCreateFailed = (serialNumber, error) => ({
  type: VEHICLE_SNAPSHOT_CREATE_FAILED,
  payload: { serialNumber, error },
})

export const deleteVehicleSnapshot = (serialNumber, snapshotId) => ({
  type: DELETE_VEHICLE_SNAPSHOT,
  payload: { serialNumber, snapshotId },
})

export const vehicleSnapshotDeleted = (serialNumber, snapshotId) => ({
  type: VEHICLE_SNAPSHOT_DELETED,
  payload: { serialNumber, snapshotId },
})

export const vehicleSnapshotDeleteFailed = (
  serialNumber,
  snapshotId,
  error
) => ({
  type: VEHICLE_SNAPSHOT_DELETE_FAILED,
  payload: { serialNumber, snapshotId, error },
})

export const FETCH_VEHICLE_AS_BUILT = 'FETCH_VEHICLE_AS_BUILT'
export const VEHICLE_AS_BUILT_RECEIVED = 'VEHICLE_AS_BUILT_RECEIVED'
export const VEHICLE_AS_BUILT_FAILED = 'VEHICLE_AS_BUILT_FAILED'

export const fetchVehicleAsBuilt = (serialNumber) => ({
  type: FETCH_VEHICLE_AS_BUILT,
  payload: { serialNumber },
})

export const vehicleAsBuiltReceived = (serialNumber, data) => ({
  type: VEHICLE_AS_BUILT_RECEIVED,
  payload: { serialNumber, data },
})

export const vehicleAsBuiltFailed = (serialNumber, error) => ({
  type: VEHICLE_AS_BUILT_FAILED,
  payload: { serialNumber, error },
})
